"use strict"; // tslint:disable:max-classes-per-file

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFramePayIBANComponent = exports.withFramePayBankComponent = exports.withFramePayCardComponent = exports.withFramePay = void 0;

var React = __importStar(require("react"));

var context_1 = require("../context");

var applepay_element_1 = __importDefault(require("./elements/applepay-element"));

var bank_element_1 = __importDefault(require("./elements/bank-element"));

var card_element_1 = __importDefault(require("./elements/card-element"));

var digitalwallet_element_1 = __importDefault(require("./elements/digitalwallet-element"));

var iban_element_1 = __importDefault(require("./elements/iban-element"));

var makeRebillyProps = function makeRebillyProps(data) {
  return Object.assign(Object.create(data.api || {}), {
    error: data.error,
    ready: data.ready
  });
};

function Hoc(name, WrappedComponent, provider) {
  var _a;

  return _a = function (_super) {
    __extends(class_1, _super);

    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    class_1.prototype.render = function () {
      var _this = this;

      return React.createElement(context_1.ContextConsumer, null, function (data) {
        var provided = provider(data);
        return React.createElement(WrappedComponent, __assign({}, __assign(__assign({}, _this.props), provided)));
      });
    };

    return class_1;
  }(React.Component), _a.displayName = "withFramePay" + name + "(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _a;
}
/**
 * Returns the PaymentElementWrapper elements.
 *
 * @param type {string} PaymentElements
 */


var elementsFabric = function elementsFabric(type) {
  if (type === 'iban') {
    /**
     * IBAN
     */

    /**
     * IBAN number element
     */
    var IBANElement = Hoc('IBANElement', iban_element_1.default, function (data) {
      return {
        Rebilly: makeRebillyProps(data),
        elementType: 'iban'
      };
    });
    return {
      IBANElement: IBANElement
    };
  }

  if (type === 'bankAccount') {
    /**
     * BankAccount
     * @see https://rebilly.github.io/framepay-docs/reference/rebilly.html#rebilly-bankaccount-mount
     */

    /**
     * Bank AccountType Element
     */
    var BankAccountTypeElement = Hoc('BankAccountTypeElement', bank_element_1.default, function (data) {
      return {
        Rebilly: makeRebillyProps(data),
        elementType: 'bankAccountType'
      };
    });
    /**
     * BankRoutingNumber Element
     */

    var BankRoutingNumberElement = Hoc('BankRoutingNumberElement', bank_element_1.default, function (data) {
      return {
        Rebilly: makeRebillyProps(data),
        elementType: 'bankRoutingNumber'
      };
    });
    /**
     * Bank AccountNumber Element
     */

    var BankAccountNumberElement = Hoc('BankAccountNumberElement', bank_element_1.default, function (data) {
      return {
        Rebilly: makeRebillyProps(data),
        elementType: 'bankAccountNumber'
      };
    });
    return {
      BankAccountNumberElement: BankAccountNumberElement,
      BankAccountTypeElement: BankAccountTypeElement,
      BankRoutingNumberElement: BankRoutingNumberElement
    };
  }

  if (type === 'card') {
    /**
     * Default Card Element
     * @see https://rebilly.github.io/framepay-docs/reference/rebilly.html#rebilly-card-mount
     */
    var CardElement = Hoc('CardElement', card_element_1.default, function (data) {
      return {
        Rebilly: makeRebillyProps(data)
      };
    });
    /**
     * Card CVV Element
     */

    var CardCvvElement = Hoc('CardCvvElement', card_element_1.default, function (data) {
      return {
        Rebilly: makeRebillyProps(data),
        elementType: 'cardCvv'
      };
    });
    /**
     * Card Expiry Element
     */

    var CardExpiryElement = Hoc('CardExpiryElement', card_element_1.default, function (data) {
      return {
        Rebilly: makeRebillyProps(data),
        elementType: 'cardExpiry'
      };
    });
    /**
     * Card Number Element
     */

    var CardNumberElement = Hoc('CardNumberElement', card_element_1.default, function (data) {
      return {
        Rebilly: makeRebillyProps(data),
        elementType: 'cardNumber'
      };
    });
    return {
      CardCvvElement: CardCvvElement,
      CardElement: CardElement,
      CardExpiryElement: CardExpiryElement,
      CardNumberElement: CardNumberElement
    };
  }

  if (type === 'applePay') {
    /**
     * Apple Pay
     */
    var ApplePayElement = Hoc('ApplePayElement', applepay_element_1.default, function (data) {
      return {
        Rebilly: makeRebillyProps(data)
      };
    });
    return {
      ApplePayElement: ApplePayElement
    };
  }

  if (type === 'digitalWallet') {
    /**
     * Digital Wallet
     */
    var DigitalWalletElement = Hoc('DigitalWalletElement', digitalwallet_element_1.default, function (data) {
      return {
        Rebilly: makeRebillyProps(data)
      };
    });
    return {
      DigitalWalletElement: DigitalWalletElement
    };
  }
  /**
   * Throw the error by default.
   */


  throw new Error("Invalid PaymentMethod type, see PaymentMethodTypes declaration");
};

function withFramePay(WrappedComponent) {
  var _a;

  var elements = __assign(__assign(__assign(__assign(__assign({}, elementsFabric('card')), elementsFabric('bankAccount')), elementsFabric('iban')), elementsFabric('applePay')), elementsFabric('digitalWallet'));

  return _a = function (_super) {
    __extends(class_2, _super);

    function class_2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    class_2.prototype.render = function () {
      var _this = this;

      return React.createElement(context_1.ContextConsumer, null, function (data) {
        return React.createElement(WrappedComponent, __assign({}, __assign(__assign(__assign({}, _this.props), elements), {
          Rebilly: makeRebillyProps(data)
        })));
      });
    };

    return class_2;
  }(React.Component), _a.displayName = "withFramePay" + name + "(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _a;
}

exports.withFramePay = withFramePay;

function withFramePayCardComponent(WrappedComponent) {
  var _a;

  var elements = elementsFabric('card');
  return _a = function (_super) {
    __extends(class_3, _super);

    function class_3() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    class_3.prototype.render = function () {
      var _this = this;

      return React.createElement(context_1.ContextConsumer, null, function (data) {
        return React.createElement(WrappedComponent, __assign({}, __assign(__assign(__assign({}, _this.props), elements), {
          Rebilly: makeRebillyProps(data)
        })));
      });
    };

    return class_3;
  }(React.Component), _a.displayName = "withFramePayCardComponent" + name + "(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _a;
}

exports.withFramePayCardComponent = withFramePayCardComponent;

function withFramePayBankComponent(WrappedComponent) {
  var _a;

  var elements = elementsFabric('bankAccount');
  return _a = function (_super) {
    __extends(class_4, _super);

    function class_4() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    class_4.prototype.render = function () {
      var _this = this;

      return React.createElement(context_1.ContextConsumer, null, function (data) {
        return React.createElement(WrappedComponent, __assign({}, __assign(__assign(__assign({}, _this.props), elements), {
          Rebilly: makeRebillyProps(data)
        })));
      });
    };

    return class_4;
  }(React.Component), _a.displayName = "withFramePayBankComponent" + name + "(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _a;
}

exports.withFramePayBankComponent = withFramePayBankComponent;

function withFramePayIBANComponent(WrappedComponent) {
  var _a;

  var elements = elementsFabric('iban');
  return _a = function (_super) {
    __extends(class_5, _super);

    function class_5() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    class_5.prototype.render = function () {
      var _this = this;

      return React.createElement(context_1.ContextConsumer, null, function (data) {
        return React.createElement(WrappedComponent, __assign({}, __assign(__assign(__assign({}, _this.props), elements), {
          Rebilly: makeRebillyProps(data)
        })));
      });
    };

    return class_5;
  }(React.Component), _a.displayName = "withFramePayIBANComponent" + name + "(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _a;
}

exports.withFramePayIBANComponent = withFramePayIBANComponent;